import axios from "../../../../../axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./edit_deletePost.css";
import { toast } from "react-toastify";

const DeletePost = ({
  setDelet1,
  communityId,
  post_id,
  refetch1,
  setOpenPopup,
}) => {
  const navigate = useNavigate();

  // const [postDeleted, setPostDeleted] = useState(false);
  const [isFeed, setIsFeed] = useState(false);
  let user_id = JSON.parse(localStorage.getItem("Teacher_id"));
  useEffect(() => {
    var currentURL = window.location.href;
    var desiredPath = "/feedDetail";
    if (currentURL.includes(desiredPath)) {
      setIsFeed(true);
    } else {
      setIsFeed(false);
    }
  }, []);
  const handelDeletePost = async () => {
    try {
      let res = await axios.delete(
        `/api/v1/community/${communityId}/post/delete/${post_id}`,
        { data: { user_id } },
      );

      if (res?.data?.status) {
        toast.success("Post deleted successfully");
        setDelet1(false);
        if (setOpenPopup) setOpenPopup(false);

        const isOnSamePage = window.location.pathname === "/TotalCommuPost";

        if (isOnSamePage) {
          // Already on the page — just fire the event, no navigate needed
          window.dispatchEvent(new CustomEvent("POST_DELETED"));
        } else {
          // Different page — navigate, then use the localStorage flag on mount
          localStorage.setItem("POST_RELOAD", "true");
          navigate("/TotalCommuPost", { replace: true });
        }
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong while deleting");
    }
  };

  return (
    <>
      <div className=" delete_post_transprant_body ">
        <img
          src="/images/cross-circle3.svg"
          className=" delete_post_close_btn"
          alt=""
          onClick={(e) => setDelet1(false)}
        />
        <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_post_container shadow z-20">
          <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
            <span className="mt-4 mb-5 delete_post_text">
              Are you sure you want to delete this post?
            </span>
            <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
              <button
                className="btn btn-danger col-sm-5  post_delete_btn"
                onClick={handelDeletePost}
              >
                Yes
              </button>
              <button
                className="btn btn-danger col-sm-5 post_delete_btn no"
                // autoFocus
                onClick={(e) => setDelet1(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeletePost;
